export enum AdminOrderCollectionAction {
  MarkAsComplete,
  MarkAsCompletedPending,
  DownloadLabels,
}
